<template>
  <div class="v-diamondTableWrap">
    <table class="v-diamondTable">
      <thead class="v-diamondTable__thead">
        <tr class="v-diamondTable__row">
          <th v-if="showPrice" scope="col" class="v-diamondTable__cell -th"></th>
          <th scope="col" class="v-diamondTable__cell -th">{{ $t("DiamondList.headers.shape") }}</th>
          <th scope="col" class="v-diamondTable__cell -th">{{ $t("DiamondList.headers.carat") }}</th>
          <th v-if="showPrice" scope="col" class="v-diamondTable__cell -th">{{ $t("DiamondList.headers.price") }}</th>
          <th scope="col" class="v-diamondTable__cell -th">{{ $t("DiamondList.headers.color") }}</th>
          <th scope="col" class="v-diamondTable__cell -th">{{ $t("DiamondList.headers.clarity") }}</th>
          <th scope="col" class="v-diamondTable__cell -th">{{ $t("DiamondList.headers.cut") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="d in diamonds" :key="d.id" class="v-diamondTable__row">
          <td v-if="showPrice" class="v-diamondTable__cell -td">
            <a class="v-diamondTable__anchor"
              :href="'/collections/diamonds/' + d.id"
            >
              <span class="v-diamondTable__button">{{ $t("DiamondList.show_details") }}</span>
            </a>
          </td>
          <td class="v-diamondTable__cell -td">
            <svg :title="shapeLabel(d.shape)" width="25" height="25" viewBox="0 0 110 110">
              <use
                x="0" y="0" width="110" height="110" stroke-width="2"
                :href="'#diamond_symbol_' + d.shape"
              ></use>
            </svg>
          </td>
          <td class="v-diamondTable__cell -td"><b>{{ zeroPaddingDecimalPoint(d.weight, 3) }}ct</b></td>
          <td v-if="showPrice" class="v-diamondTable__cell -td"><b>{{ numberWithCommas(d.price) }}</b></td>
          <td class="v-diamondTable__cell -td"><b>{{ d.color_grade }}</b></td>
          <td class="v-diamondTable__cell -td"><b>{{ d.clarity_grade }}</b></td>
          <td class="v-diamondTable__cell -td"><b>{{ cutGradeLabel(d.cut_grade) }}</b></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { numberWithCommas } from "../../../../shared/utilities"

export default {
  props: {
    diamonds: {
      type: Array,
      default: [],
    },
    shapeTranslations: {
      type: Array,
      default: [],
    },
    cutGradeTranslations: {
      type: Array,
      default: [],
    },
    shapeLabel: {
      type: Function,
      required: true,
    },
    cutGradeLabel: {
      type: Function,
      required: true,
    },
    showPrice: {
      type: Boolean,
      default: true,
    }
  },

  name: 'DiamondList',

  methods: {
    numberWithCommas,

    /**
     * 切り捨て後、ゼロパディング
     * toFixed四捨五入だけだとしてしまうため）
     * @param  {Number} value 値
     * @param  {Number} digits 小数点第〇位まで表示するか (ex. 3 -> 0.100)
     * @return {String}       返り値の説明
     */
    zeroPaddingDecimalPoint(value, digits) {
      const result = (Math.floor(value * Math.pow(10, digits)) / Math.pow(10, digits)).toFixed(digits);
      return result;
    }
  },
}
</script>

<style lang="scss" scoped>
  .v-diamondTableWrap {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    padding: 0 0 20px;
    margin: 10px 0;

    @media screen and (min-width: 1200px) {
      margin: 0;
    }
  }

  .v-diamondTable {
    width: 100%;
    font-size: 10px;

    @media screen and (min-width: 900px) {
      font-size: 12px;
    }

    &__thead {
      background: #f1f1f1;
    }

    &__cell {
      padding: 10px 15px;;
      white-space: nowrap;
      text-align: center;
      border-bottom: 1px solid #e6e6e6;
      vertical-align: middle;
    }

    &__anchor {
      display: flex;
      justify-content: center;
      align-items: center;
      text-decoration: none;
      height: 100%;
    }

    &__button {
      border: 1px solid #666;
      border-radius: 3px;
      padding: 4px 5px;
      line-height: 1;
    }
  }
</style>
